import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="min-h-screen" style={{ background: "#0B1622" }}>
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link
          to="/"
          data-testid="back-to-home-link"
          className="inline-flex items-center gap-2 mb-8 text-sm"
          style={{ color: "#94A3B8" }}
        >
          <ArrowLeft className="w-4 h-4" /> Volver
        </Link>

        <h1
          className="text-3xl sm:text-4xl font-bold mb-2"
          style={{ color: "#E2E8F0", fontFamily: "'Space Grotesk', serif" }}
        >
          Términos y Condiciones
        </h1>
        <p className="text-sm mb-8" style={{ color: "#64748B" }}>
          Última actualización: Febrero 2026
        </p>

        <div
          className="prose prose-invert max-w-none space-y-6"
          style={{ color: "#CBD5E1", fontFamily: "'Crimson Pro', serif", fontSize: "16px", lineHeight: 1.8 }}
        >
          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: "#E2E8F0", fontFamily: "'Space Grotesk', serif" }}>
              1. Aceptación de los términos
            </h2>
            <p>
              Al registrarte o utilizar La Forja de Contenidos (en adelante, "la Plataforma"), aceptas expresamente estos Términos y Condiciones. Si no estás de acuerdo con alguno de ellos, debes abstenerte de usar el servicio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: "#E2E8F0", fontFamily: "'Space Grotesk', serif" }}>
              2. Descripción del servicio
            </h2>
            <p>
              La Forja de Contenidos es una plataforma de generación asistida de contenido mediante inteligencia artificial. Permite producir artículos, adaptaciones para redes sociales, imágenes y contenidos derivados a partir de las indicaciones del usuario y de modelos de IA de terceros.
            </p>
          </section>

          <section
            data-testid="ai-disclaimer-section"
            className="rounded-lg p-5"
            style={{ background: "rgba(0,212,255,0.04)", border: "1px solid rgba(0,212,255,0.15)" }}
          >
            <h2 className="text-xl font-semibold mb-3" style={{ color: "#00D4FF", fontFamily: "'Space Grotesk', serif" }}>
              3. Limitación de responsabilidad sobre el contenido generado
            </h2>
            <p>
              La Forja de Contenidos utiliza inteligencia artificial para generar contenido. El contenido generado por la plataforma es <strong>orientativo</strong> y no garantiza veracidad, exactitud, originalidad ni ausencia de errores.
            </p>
            <p className="mt-3">
              <strong>El usuario es el único responsable</strong> de revisar, verificar y aprobar el contenido antes de su publicación. La Forja de Contenidos no se hace responsable de los daños directos o indirectos derivados del uso del contenido generado, incluyendo pero no limitado a:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Errores de datos o estadísticas.</li>
              <li>Afirmaciones no verificadas.</li>
              <li>Contenido que pueda infringir derechos de terceros.</li>
              <li>Perjuicio reputacional o comercial derivado de la publicación del contenido sin revisión previa.</li>
            </ul>
            <p className="mt-3">
              El contenido generado <strong>no constituye en ningún caso asesoramiento legal, médico, financiero, psicológico ni de ningún otro tipo profesional</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: "#E2E8F0", fontFamily: "'Space Grotesk', serif" }}>
              4. Uso aceptable
            </h2>
            <p>
              El usuario se compromete a no utilizar la Plataforma para generar contenido ilegal, difamatorio, discriminatorio, violento, sexualmente explícito o que vulnere derechos de terceros.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: "#E2E8F0", fontFamily: "'Space Grotesk', serif" }}>
              5. Propiedad intelectual
            </h2>
            <p>
              El usuario conserva los derechos sobre el contenido generado a partir de sus propias indicaciones, siempre sujeto a las condiciones de uso de los proveedores de IA subyacentes y de las imágenes generadas.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: "#E2E8F0", fontFamily: "'Space Grotesk', serif" }}>
              6. Pagos, créditos y cancelación
            </h2>
            <p>
              Las suscripciones y packs de créditos se gestionan a través de Stripe. Los créditos no utilizados dentro del periodo de facturación pueden perderse según el plan contratado. Puedes cancelar tu suscripción en cualquier momento desde tu panel.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: "#E2E8F0", fontFamily: "'Space Grotesk', serif" }}>
              7. Modificaciones
            </h2>
            <p>
              La Forja de Contenidos se reserva el derecho de modificar estos términos en cualquier momento. Las modificaciones se notificarán con al menos 15 días de antelación cuando sean sustanciales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: "#E2E8F0", fontFamily: "'Space Grotesk', serif" }}>
              8. Contacto
            </h2>
            <p>
              Para cualquier consulta sobre estos términos, puedes contactarnos desde tu panel de usuario o por email.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
